import { Component } from 'react';

import GoogleAnalytics from 'react-g-analytics';
import { analytics } from '../data';

import Header from './modules/Header';
import Footer from './modules/Footer';
import Navigation from './modules/Navigation';

class App extends Component {
  render() {
    return (
      <div className="wrapper">
        <GoogleAnalytics id={analytics.id} />
        <Header />
        <Navigation />
        <main className="page-main">
          { this.props.children }
        </main>
        <Footer />
      </div>
    )
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/